import { SHOW_BUSINESS_MODAL, SHOW_TIER_MODAL } from './types'
export const showBusinessModal = (payload) => {
    return {
        type: SHOW_BUSINESS_MODAL,
        payload: payload
    }
}

export const showTierModal = (payload) => {
    return {
        type: SHOW_TIER_MODAL,
        payload: payload
    }
}
